<template>
  <div>
    <div class="col-md-12">
      <div
        class="warning-reminder p-3"
        style="width:100%;  background-color : #fbfb83"
        v-if="
          (addActive.data.sisa_kuota_sms == 0 &&
            addActive.data.sisa_kuota_wa == 0) ||
            (addActive.data.sisa_kuota_sms == 'TIDAK DIAKTIFKAN' &&
              addActive.data.sisa_kuota_wa == 0) ||
            (addActive.data.sisa_kuota_wa == 'TIDAK DIAKTIFKAN' &&
              addActive.data.sisa_kuota_sms == 0)
        "
      >
        <h5 style="font-weight:700;font-size:15px;margin-bottom:0px;">
          Kuota Whatsapp/SMS Patient Engagement Anda telah HABIS! Tambah kuota
          sekarang untuk tetap terhubung dengan pasien Anda!
        </h5>
      </div>
      <div
        class="warning-reminder p-3"
        style="width:100%;  background-color : #fbfb83"
        v-else-if="
          (addActive.data.sisa_kuota_sms <= 10 &&
            addActive.data.sisa_kuota_wa == 0) ||
            (addActive.data.sisa_kuota_wa <= 10 &&
              addActive.data.sisa_kuota_sms == 0) ||
            (addActive.data.sisa_kuota_sms <= 10 &&
              addActive.data.sisa_kuota_wa == 'TIDAK DIAKTIFKAN') ||
            (addActive.data.sisa_kuota_wa <= 10 &&
              addActive.data.sisa_kuota_sms == 'TIDAK DIAKTIFKAN')
        "
      >
        <h5 style="font-weight:700;font-size:15px;margin-bottom:0px;">
          Kuota Whatsapp/SMS Patient Engagement Anda akan segera habis! Tambah
          kuota sekarang untuk tetap terhubung dengan pasien Anda!
        </h5>
      </div>
    </div>
    <div class="col-md-12 " style="font-size:13px;">
      <div class="card card-box mb-2">
        <div class="card-body">
          <div class="row" style="color: #5581af;">
            <div class="col-md-12">
              <h6>
                <strong>Pengguna Kuota Bulan ini, {{ now }}</strong>
              </h6>
            </div>
            <div class="col-md-3 mt-3 ml-4 mr-4">
              <strong>1. Pesan Reminder Konsultasi</strong><br />
              <strong
                >SMS Terkirim :
                <span
                  :style="addActive.data.sms_terkirim == 0 ? 'color:red' : ''"
                  >{{ addActive.data.sms_terkirim }} Pesan</span
                ></strong
              ><br />
              <strong
                >WA Terkirim :
                <span
                  :style="addActive.data.wa_terkirim == 0 ? 'color:red' : ''"
                  >{{ addActive.data.wa_terkirim }} Pesan</span
                ></strong
              ><br />
            </div>
            <div class="col-md-3 mt-3 ml-4">
              <strong>2. Pesan Ulang Tahun</strong>
              <div class="media">
                <div class="media-content mr-2">
                  <strong class="ml-2">Aktifkan Channel:</strong>
                </div>
                <div class="media-right">
                  <toggle-button
                    v-model="checkedChannel"
                    :labels="{
                      checked: 'Tidak',
                      unchecked: 'Ya'
                    }"
                    :color="{
                      checked: '#f83245',
                      unchecked: '#3c44b1',
                      disabled: '#CCCCCC'
                    }"
                    :width="60"
                  />
                </div>
              </div>
              <template v-if="!checkedChannel">
                <vue-select-addons
                  class="w-50 ml-2"
                  style="width: 20px; color: #5581af; "
                  clearable="false"
                  @input="onChangeChannel(selectedChannel)"
                  :options="dataChannel"
                  v-model="selectedChannel"
                />
              </template>
              <strong class="ml-2 mt-2"
                >SMS Terkirim :
                <span
                  :style="
                    addActive.data.ultah_sms_terkirim == 0 ? 'color:red' : ''
                  "
                  >{{ addActive.data.ultah_sms_terkirim }} Pesan</span
                ></strong
              ><br />
              <strong class="ml-2"
                >WA Terkirim :
                <span
                  :style="
                    addActive.data.ultah_wa_terkirim == 0 ? 'color:red' : ''
                  "
                  >{{ addActive.data.ultah_wa_terkirim }} Pesan</span
                ></strong
              ><br />
            </div>
            <div class="col-md-4 mt-3 ml-4">
              <strong>Sisa Kuota Patient Engagement</strong><br />
              <strong
                >SMS :
                <span
                  :style="
                    addActive.data.sisa_kuota_sms <= 10 ||
                    addActive.data.sisa_kuota_sms == 'TIDAK DIAKTIFKAN'
                      ? 'color:red'
                      : ''
                  "
                  >{{ addActive.data.sisa_kuota_sms }}
                  {{
                    addActive.data.sisa_kuota_sms != "TIDAK DIAKTIFKAN"
                      ? "Pesan"
                      : ""
                  }}</span
                ></strong
              ><br />
              <strong
                >WA :
                <span
                  :style="
                    addActive.data.sisa_kuota_wa <= 10 ||
                    addActive.data.sisa_kuota_wa == 'TIDAK DIAKTIFKAN'
                      ? 'color:red'
                      : ''
                  "
                  >{{ addActive.data.sisa_kuota_wa }}
                  {{
                    addActive.data.sisa_kuota_wa != "TIDAK DIAKTIFKAN"
                      ? "Pesan"
                      : ""
                  }}</span
                ></strong
              ><br />
              <router-link
                style="width: 200px;"
                :to="{ name: 'subskripsi' }"
                class="btn btn-primary text-uppercase btn-radius mt-2 mb-4"
              >
                Tambah Kuota
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="ScrollActivate" class="col-md-12">
      <div class="card card-box mb-2 mt-3" style="border-radius:0px;">
        <div class="card-body" style="font-size: 13px;">
          <div class="row" style="color: #5581af;">
            <div
              class="col-md-auto"
              style=" padding-top: 11px; margin-left: 30px; margin-right: 10px; margin-top: 20px; padding: 0;"
            >
              <strong>Periode Pengiriman :</strong>
            </div>
            <div class="col-md-auto" style="margin-top:20px;">
              <DatePickerX
                style="padding: 5px; font-size: 13px;"
                v-model="dateRange"
                :popover="{
                  placement: 'auto',
                  visibility: 'click',
                  positionFixed: true
                }"
                mode="range"
                :input-props="{ placeholder: 'Pilih Tanggal', readonly: true }"
                :masks="{ input: 'DD-MM-YYYY' }"
                :max-date="maxDate"
                :min-date="minDate"
                :is-required="true"
              />
            </div>
          </div>
          <div class="row" style="color: #5581af;">
            <div
              class="col-md-auto"
              style="padding-top: 11px; margin-left: 30px; margin-right: 10px; margin-top: 0px; padding: 0;"
            >
              <strong>Sort By :</strong>
            </div>
            <div
              class="col-md-3"
              style="margin-left: 82px; margin-bottom: 20px;"
            >
              <vue-select
                class="ml-2"
                clearable="false"
                :options="dataSort"
                v-model="selectedSort"
                :reduce="dataSort => selectedSort.value"
              />
            </div>
          </div>
          <DataTableWrapper
            :perPage="perPage"
            :currentPage="currentPage"
            :rows="rows"
            :fromPage="fromPage"
            :toPage="toPage"
            @pageChanged="handleValueChanged"
            style="font-size: 12px; margin:10px;"
          >
            <template v-slot:right-header>
              <b-button
                variant="success"
                class="text-uppercase align-self-end mr-3"
                @click="donwload"
                :disabled="dataTableAddons.length > 0 ? false : true"
              >
                <font-awesome-icon icon="download" />
                Download Report
              </b-button>
            </template>
            <b-table
              :items="dataTableAddons"
              :fields="fieldList"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              thead-tr-class="izd-datatable"
              :no-local-sorting="true"
            >
              <template v-slot:head()="data">
                {{ data.label }}
                <b-input
                  size="sm"
                  class="mt-2 w-70"
                  v-if="data.field.searchable"
                  @input="searchValueChanged($event, data.field.key)"
                />
              </template>
              <template v-slot:cell(status)="data">
                <template v-if="data.item.status === 'Sukses'">
                  <strong class="">{{ data.item.status }}</strong>
                </template>
                <template v-else-if="data.item.status === 'Menunggu'">
                  <strong class="">{{ data.item.status }}</strong>
                </template>
                <template v-else-if="data.item.status === 'Gagal'">
                  <strong class=""
                    >{{ data.item.status }}
                    <font-awesome-icon
                      v-tooltip.bottom-start="
                        'Untuk pertanyaan terkait status pengiriman pesan yang gagal, silakan hub. 021-7237982'
                      "
                      class="mx-auto"
                      icon="info-circle"
                  /></strong>
                </template>
              </template>
              <template v-slot:cell(DETAIL)="data">
                <span>
                  <b-dropdown
                    id="dropdown-1"
                    class="text-capitalize"
                    variant="primary"
                    size="sm"
                    right
                  >
                    <template v-slot:button-content>
                      <font-awesome-icon icon="copy" />
                    </template>
                    <b-dropdown-item @click="detailAddons(data.item.id_pesan)"
                      >Lihat Pesan</b-dropdown-item
                    >
                    <template
                      v-if="data.item.jenis_pesan === 'Reminder Konsultasi'"
                    >
                      <b-dropdown-item
                        @click="
                          rekamMedis({
                            pasien_id: data.item.id_pasien
                          })
                        "
                        >Lihat Rekam Medis</b-dropdown-item
                      >
                    </template>
                  </b-dropdown>
                </span>
              </template>
            </b-table>
          </DataTableWrapper>
          <b-modal class="modal-backdrop" size="lg" ref="modal-detailaddons">
            <div
              class="row ml-2"
              v-if="this.detailPopUpAddons !== null"
              style="font-size:13px; color: #5581af;"
            >
              <div class="col-lg-3">
                <label class="float-left"><strong>Nama Pasien</strong></label>
              </div>
              <div class="col-lg-3">
                <label class="float-left"
                  ><strong>: {{ detailPopUpAddons.nama_pasien }}</strong></label
                >
              </div>
              <div class="col-lg-3">
                <label class="float-left"><strong>No. Handphone</strong></label>
              </div>
              <div class="col-lg-3">
                <label class="float-left"
                  ><strong
                    >: {{ detailPopUpAddons.nomor_hp_pasien }}</strong
                  ></label
                >
              </div>
            </div>
            <div
              class="row ml-2"
              v-if="this.detailPopUpAddons !== null"
              style="font-size:13px; color: #5581af;"
            >
              <div class="col-lg-3">
                <label class="float-left"
                  ><strong>Tanggal Terkirim</strong></label
                >
              </div>
              <div class="col-lg-3">
                <label class="float-left"
                  ><strong
                    >: {{ detailPopUpAddons.tanggal_terkirim }}</strong
                  ></label
                >
              </div>
              <div class="col-lg-3">
                <label class="float-left"><strong>ID Pesan</strong></label>
              </div>
              <div class="col-lg-3">
                <label class="float-left"
                  ><strong>: {{ detailPopUpAddons.id_pesan }}</strong></label
                >
              </div>
            </div>
            <div
              class="row ml-2"
              v-if="this.detailPopUpAddons !== null"
              style="font-size:13px; color: #5581af;"
            >
              <div class="col-lg-3">
                <label class="float-left"
                  ><strong>Tanggal Visit Terakhir</strong></label
                >
              </div>
              <div class="col-lg-3">
                <label class="float-left"
                  ><strong
                    >: {{ detailPopUpAddons.tanggal_visit_terkahir }}</strong
                  ></label
                >
              </div>
              <div class="col-lg-3">
                <label class="float-left"><strong>Channel</strong></label>
              </div>
              <div class="col-lg-3">
                <label class="float-left"
                  ><strong>: {{ detailPopUpAddons.tipe_addson }}</strong></label
                >
              </div>
            </div>
            <div
              class="row ml-2"
              v-if="this.detailPopUpAddons !== null"
              style="font-size:13px; color: #5581af;"
            >
              <div class="col-lg-3">
                <label class="float-left"><strong>Nama Pengirim</strong></label>
              </div>
              <div class="col-lg-3">
                <label class="float-left"
                  ><strong
                    >: {{ detailPopUpAddons.nama_pengirim }}</strong
                  ></label
                >
              </div>
              <div class="col-lg-3">
                <label class="float-left"
                  ><strong>No. Tlp Pengirim</strong></label
                >
              </div>
              <div class="col-lg-3">
                <label class="float-left"
                  ><strong
                    >: {{ detailPopUpAddons.nomor_pengirim }}
                    <font-awesome-icon
                      v-tooltip.bottom-start="
                        'Untuk mencantumkan no. lain, silakan isi No. Telp Tempat Praktik pada menu Account Setting - Profil Dokter'
                      "
                      class="mx-auto"
                      icon="info-circle"/></strong
                ></label>
              </div>
            </div>
            <br />
            <div
              class="row ml-2"
              v-if="this.detailPopUpAddons !== null"
              style="font-size:13px; color: #5581af;"
            >
              <div class="col-lg-3">
                <label class="float-left"><strong>Jenis Pesan</strong></label>
              </div>
              <div class="col-lg-3">
                <label class="float-left"
                  ><strong>: {{ detailPopUpAddons.jenis_pesan }}</strong></label
                >
              </div>
              <div class="col-lg-3">
                <label class="float-left"><strong>Status</strong></label>
              </div>
              <div class="col-lg-3">
                <label class="float-left"
                  ><strong>: {{ detailPopUpAddons.status }}</strong></label
                >
              </div>
            </div>
            <br />
            <div
              class="row ml-2"
              v-if="this.detailPopUpAddons !== null"
              style="font-size:14px; color: #5581af; "
            >
              <div class="col-lg-12">
                <p><strong>Isi Pesan</strong></p>
              </div>
              <br />
              <div
                class="col-lg-10 ml-5 mr-5"
                style="font-size:11px; color: #5581af; border-radius: 10px; background: #f5f5f5; "
              >
                <p class="mt-5 mb-5 ml-5 mr-5">
                  <strong>{{ detailPopUpAddons.isi }}</strong>
                </p>
              </div>
            </div>
            <div slot="modal-footer">
              <div class="align-content-center">
                <b-button
                  variant="danger"
                  rclass="btn-link-dark mr-4"
                  @click="close()"
                  >Tutup</b-button
                >
              </div>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import axios from "axios";
import moment from "moment";
moment.locale("id");
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowRight,
  faArrowUp,
  faTrashAlt,
  faEye,
  faEyeSlash,
  faCopy,
  faSearch,
  faPencilAlt,
  faDownload,
  faMoneyBillWave
} from "@fortawesome/free-solid-svg-icons";
import { faCalendar, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import startCase from "lodash/startCase";
import { EventBus } from "../../event-bus";
library.add(
  faInfoCircle,
  faArrowRight,
  faEye,
  faMoneyBillWave,
  faCopy,
  faEyeSlash,
  faArrowUp,
  faTrashAlt,
  faSearch,
  faDownload,
  faPencilAlt
);
import { ToggleButton } from "vue-js-toggle-button";

export default {
  components: {
    DatePickerX: () => import("v-calendar/lib/components/date-picker.umd"),
    "vue-select-addons": () => import("@/components/VueSelectAddOns.vue"),
    "vue-select": () => import("@/components/VueSelect.vue"),
    DataTableWrapper: () => import("../../components/DataTableWrapper2"),
    "toggle-button": ToggleButton
  },
  data() {
    return {
      dataTagihan: [],
      dataDetailRiwayatPembelian: [],
      dataTableAddons: [],
      dataNotActive: [],
      dataActive: [],
      dateRange: {
        start: moment()
          .add(-2, "days")
          .toDate(),
        end: moment().toDate()
      },
      dataExpired: [
        {
          nama: null
        }
      ],
      detailStruk: null,
      checkDataInvoice: [],
      belumAktif: [],
      searchValue: [],
      adaTagihan: false,
      detail: null,
      sortBy: "",
      sortDesc: false,
      currentPage: 1,
      rows: 0,
      fromPage: 0,
      toPage: 0,
      perPage: 10,
      selectedChannel: null,
      dataChannel: [],
      checkedChannel: false,
      selectedSort: "Newest Date",
      dataSort: ["Newest Date", "Oldest Date"],
      dataPaketExpired: [],
      currentPageExpired: 1,
      perPageExpired: 5,
      rowsExpired: 0,
      dataDetailAddons: null,
      currentPageNotActive: 1,
      perPageBelumAktif: 5,
      rowsBelumAktif: 0,
      periodeSelected: "pilih tanggal",
      fromPageBelumAktif: 0,
      addActive: null,
      toPageBelumAktif: 0,
      detailPopUpAddons: [],
      dataPackage: {},
      dataAddOn: {}
    };
  },
  async mounted() {
    this.cekPaketNolock();
    this.checkAddons();
    this.fetchListNotActive();
    this.fetchListExpired();
    this.fetchTableAddons();
    this.fetchActive();
    await this.checkBilling();
  },
  watch: {
    currentPageNotActive() {
      this.fetchListNotActive();
    },
    currentPageExpired() {
      this.fetchListExpired();
    },
    sortBy() {
      this.fetchTableAddons();
    },
    sortDesc() {
      this.fetchTableAddons();
    },
    periodeSelected(val) {
      this.fetchTableAddons();
    },
    selectedSort: {
      handler: function() {
        if (this.periodeSelected === "pilih tanggal") {
          this.fetchTableAddons();
        }
      },
      deep: true
    },
    dateRange: {
      handler: function() {
        if (this.periodeSelected === "pilih tanggal") {
          this.fetchTableAddons();
        }
      },
      deep: true
    },
    searchValue: {
      handler: "fetchTableAddons",
      deep: true
    },
    checkedChannel() {
      if (this.checkedChannel) {
        this.offChannel();
      } else {
        this.onChannel();
      }
    }
  },
  computed: {
    now() {
      return moment().format("LL");
    },
    minDate() {
      return moment()
        .subtract(3, "months")
        .toDate();
    },
    maxDate() {
      return moment()
        .add(2, "months")
        .toDate();
    },
    fieldList() {
      const {
        generateFieldList: g,
        setSearchableAndSortableFieldList: s
      } = this;
      const r = val => Boolean(/(no|DETAIL)\b/gi.test(val) ? !1 : 1);
      return (
        [
          {
            key: "no",
            label: "No",
            thStyle: "width: 5%"
          },
          {
            key: "id_pesan",
            label: "ID PESAN",
            thStyle: "width: 14%"
          },
          {
            key: "tanggal_terkirim",
            label: "TANGGAL PENGIRIMAN",
            thStyle: "width: 15%"
          },
          {
            key: "nama_pasien",
            label: "NAMA PASIEN",
            thStyle: "width: 13%"
          },
          {
            key: "nomor_hp_pasien",
            label: "NO. HANDPHONE",
            thStyle: "width: 15%",
            class: ""
          },
          {
            key: "status",
            label: "STATUS",
            thStyle: "width: 13%"
          },
          {
            key: "jenis_pesan",
            label: "JENIS PESAN",
            thStyle: "width: 13%"
          },
          {
            key: "tipe_addson",
            label: "CHANNEL",
            thStyle: "width: 18%"
          },
          {
            key: "DETAIL",
            thStyle: "width: 20%"
          }
        ]
        |> (v =>
          s({
            field: v,
            customFunc: r
          }))
        |> (z =>
          g({
            field: z
          }))
      );
    }
  },
  methods: {
    async rekamMedis({ pasien_id }) {

      let res = await axios.get(`${this.url_api}/pasien/${pasien_id}`);
      if (res.data.status == false || res.data.data_rm == false) {
        this.$swal({
          type: "error",
          title: startCase("Gagal"),
          text: startCase(`Pasien ${res.data.data.nama} belum memiliki rekam medis!`)
        });
      }else{        
        localStorage.setItem("rekam_medis", window.location.pathname);
        this.$router.push({
          name: "riwayat-rekam-medis",
          params: {
            pasien_id: pasien_id
          }
        });
      }
    },
    async checkAddons() {
      try {
        const res = await axios.get(`${this.url_api}/patient-engagement`);
        this.addActive = res.data;
        this.selectedChannel = res.data.data.ultah_channel_active;
        this.dataChannel = res.data.data.ultah_channels;

        if (this.selectedChannel == null) {
          this.checkedChannel = true;
        }
      } catch (err) {
        // console.log(err);
      }
    },
    onChangeChannel(channel) {
      if (channel) {
        const res = axios.put(`${this.url_api}/patient-engagement`, {
          channel: channel
        });
        this.checkDataInvoice = res.data;
      }
    },
    goToBayarind(item) {
      window.open(item, "_self");
    },
    convertDate(val) {
      return moment(val).format("DD MMM YYYY HH:mm:ss ");
    },
    convertDateWithoutTime(val) {
      return moment(val).format("DD MMMM YYYY");
    },
    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
    async checkBilling() {
      try {
        const res = await axios.get(`${this.url_api}/billing/package-unpaid`);
        this.checkDataInvoice = res.data;
      } catch {}
    },
    async fetchListNotActive() {
      try {
        const res = await axios.get(
          `${this.url_api}/billing/package?page=${this.currentPageNotActive}`
        );
        this.dataNotActive = res.data.data.data;
        this.rowsBelumAktif = res.data.data.total;
      } catch (err) {
        // console.log(err);
      }
    },
    caraBayar(id) {
      this.$router.push({
        name: "subskripsi-bayar",
        params: {
          bill_id: id
        }
      });
    },
    close() {
      this.$refs["modal-detailaddons"].hide();
    },
    fetchActive() {
      axios.get(`${this.url_api}/billing/package-active`).then(res => {
        this.dataActive = res.data;
        this.dataPackage = res.data.data.package;
        this.dataAddOn = res.data.data.add_on;
      });
    },
    async fetchListExpired() {
      try {
        const res = await axios.get(
          `${this.url_api}/billing/package-expired?page=${this.currentPageExpired}`
        );
        this.dataPaketExpired = res.data.data.data;
        this.rowsExpired = this.data.data.total;
      } catch (err) {
        // console.log(err);
      }
    },
    periodeX({ periode = null, rawValue = false } = {}) {
      const formatBackendDate = "YYYY-MM-DD";
      const rawValueFormat = "DD-MMM-YYYY";
      switch (periode && periode.toLowerCase()) {
        case "pilih tanggal":
          const { dateRange } = this;
          if (dateRange) {
            const { start: startDate, end: endDate } = dateRange;
            const formatDate = "DD-MM-YYYY";
            if (rawValue) {
              return `${moment(startDate, formatDate).format(
                rawValueFormat
              )}-${moment(endDate, formatDate).format(rawValueFormat)}`;
            } else {
              return `&from=${moment(startDate, formatDate).format(
                formatBackendDate
              )}&to=${moment(endDate, formatDate).format(formatBackendDate)}`;
            }
          } else {
            return null;
          }

        case "hari ini":
          const today = moment().format(formatBackendDate);
          return rawValue
            ? moment().format(rawValueFormat)
            : Array(2)
                .fill(today)
                .map(
                  (val, index) =>
                    `&${(item => (item ? "to" : "from"))(index)}=${val}`
                )
                .join("");

        case "minggu ini":
          const startWeek = moment().weekday(0);
          const endWeek = moment().weekday(6);
          return rawValue
            ? `${startWeek.format(rawValueFormat)}-${endWeek.format(
                rawValueFormat
              )}`
            : `&from=${startWeek.format(formatBackendDate)}&to=${endWeek.format(
                formatBackendDate
              )}`;

        case "bulan ini":
          const startMonth = moment().date(1);
          const endMonth = moment().date(31);
          return rawValue
            ? `${startMonth.format(rawValueFormat)}-${endMonth.format(
                rawValueFormat
              )}`
            : `&from${startMonth.format(
                formatBackendDate
              )}&to=${endMonth.format(formatBackendDate)}`;

        default:
          break;
      }
    },
    determineParameter() {
      const {
        periodeX,
        periodeSelected: periode,
        selectedSort,
        searchValue,
        sortBy,
        sortDesc
      } = this;
      let v = "";

      if (this.selectedSort === "Newest Date" && !sortBy) {
        v += `&order=desc`;
      }
      if (this.selectedSort === "Oldest Date" && !sortBy) {
        v += `&order=asc`;
      }
      if (this.dateRange !== null) {
        v += `${periodeX({ periode })}`;
      }
      searchValue.map(item => {
        const x = (item.key === "paket" && "paket") || item.key;
        v += `&${x}=${item.value}`;
      });

      if (sortBy) {
        v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
      }
      return v;
    },
    async fetchTableAddons() {
      try {
        const { searchValue, determineParameter } = this;
        if (this.dateRange === null) {
          const formatBackendDate = "YYYY-MM-DD";
          const to = moment().format(formatBackendDate);
          const from = moment()
            .add(-2, "days")
            .format(formatBackendDate);
          const res = await axios.get(
            `${this.url_api}/patient-engagement/list?limit=${this.perPage}&page=${this.currentPage}&from=${from}&to=${to}`
          );
          const { success, data } = res.data;
          if (data) {
            const { total } = data;
            const {
              data: listTableAddons,
              to: toPage,
              from: fromPage
            } = res.data.data;
            this.toPage = toPage;
            this.fromPage = fromPage;
            let tglBayar = "-";
            this.dataTableAddons = [
              ...listTableAddons.map((item, index) => {
                return {
                  ...item,
                  no: (this.currentPage - 1) * this.perPage + index + 1
                };
              })
            ];
            this.rows = data.total;
            return this;
          }
        } else {
          const res = await axios.get(
            `${this.url_api}/patient-engagement/list?limit=${
              this.perPage
            }&page=${this.currentPage}${determineParameter()}`
          );

          const { success, data } = res.data;
          if (data) {
            const { total } = data;
            const {
              data: listTableAddons,
              to: toPage,
              from: fromPage
            } = res.data.data;
            this.toPage = toPage;
            this.fromPage = fromPage;
            let tglBayar = "-";
            this.dataTableAddons = [
              ...listTableAddons.map((item, index) => {
                return {
                  ...item,
                  no: (this.currentPage - 1) * this.perPage + index + 1
                };
              })
            ];
            this.rows = data.total;
            return this;
          }
        }
      } catch (err) {
        // console.log(err);
      }
    },
    detailAddons(item) {
      this.showModalAddons();
      this.dataDetailAddons = item;

      axios
        .get(`${this.url_api}/patient-engagement/${this.dataDetailAddons}`)
        .then(res => {
          this.detailPopUpAddons = res.data.data;
        });
    },
    showModalAddons() {
      this.$refs["modal-detailaddons"].show();
    },
    downloadParameter() {
      const {
        periodeX,
        periodeSelected: periode,
        selectedSort,
        searchValue,
        sortBy,
        sortDesc
      } = this;
      let v = "";

      if (this.selectedSort === "Newest Date" && !sortBy) {
        v += `&order=desc`;
      }
      if (this.selectedSort === "Oldest Date" && !sortBy) {
        v += `&order=asc`;
      }
      if (this.dateRange !== null) {
        v += `${periodeX({ periode })}`;
      }
      searchValue.map(item => {
        const x = (item.key === "paket" && "paket") || item.key;
        v += `&${x}=${item.value}`;
      });
      return v;
    },
    async donwload() {
      const { downloadParameter } = this;
      const date = "YYYY-MM-DD";
      const to = moment().format(date);
      const from = moment()
        .add(-2, "days")
        .format(date);
      const res = await axios.get(
        `${this.url_api}/patient-engagement/download?${downloadParameter()}`,
        {
          responseType: "blob"
        }
      );

      const url = window.URL.createObjectURL(new Blob([res.data]));
      let link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Report-Patient-Engagement.xls");
      document.body.appendChild(link);
      link.click();
    },
    changePage(page) {
      this.fetchListTagihan(page);
    },
    handleValueChanged({ perPage, currentPage }) {
      if (this.perPage) this.perPage = perPage;
      if (this.perPage) this.currentPage = currentPage;
      this.fetchTableAddons();
    },
    searchValueChanged: debounce(function(val, key) {
      const { searchValue } = this;
      const z = searchValue.filter(item => item.key !== key);
      this.searchValue = [
        ...z,
        {
          key,
          value: val
        }
      ];
    }, 500),
    onChannel() {
      this.onChangeChannel(this.dataChannel[0]);
      this.selectedChannel = this.dataChannel[0];
    },
    offChannel() {
      this.onChangeChannel("deactivate");
      this.selectedChannel = null;
    }
  }
};
</script>
<style lang="scss">
.btn-paket {
  background-color: #b681fd !important;
  border-color: #b681fd !important;
  color: #ffffff !important;
}

.btn-paket:hover {
  background-color: #ac74fc !important;
  border-color: #ac74fc !important;
  color: #ffffff !important;
}

.modal-backdrop {
  opacity: 0;
}

.btn-radius {
  font-weight: bold;
  border-radius: 0.5em;
  width: 70%;
}

.card_add_on {
  background-color: #dbfbff !important;
}

.font_paket {
  font-weight: bold;
  color: #7a7a7a !important;
}
</style>
